import { render, staticRenderFns } from "./ModuleManagement.vue?vue&type=template&id=122c75ac&scoped=true"
import script from "./ModuleManagement.vue?vue&type=script&lang=js"
export * from "./ModuleManagement.vue?vue&type=script&lang=js"
import style0 from "./ModuleManagement.vue?vue&type=style&index=0&id=122c75ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122c75ac",
  null
  
)

export default component.exports